import React, { Fragment, useContext, useState, useEffect, useRef, forwardRef } from 'react';
import { Breadcrumbs, Btn, H6, H5, P } from '../../../../AbstractElements';
import ProjectContext from '../../../../_helper/Project';
import { Add, Cancel,pinagareAPIURL } from '../../../../Constant';
import { useNavigate, Link, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Container, Row, Col, Card, CardBody, Form, Label, Input, InputGroup, InputGroupText, FormGroup } from 'reactstrap';
import CustomizerContext from '../../../../_helper/Customizer';
import { ToastContainer, toast } from "react-toastify";
import CommonModal from '../../../UiKits/Modals/common/modal';
import EmailContext from '../../../../_helper/Email';
import { trackPromise } from 'react-promise-tracker';
import PromiseSpinner from '../../../../CommonElements/Spinner/PromiseSpinner';
import DatePicker from "react-datepicker";
import CreditCards from '../../Ecommerce/PaymentDetails/CreditCard';
import { getMonth, getYear } from 'date-fns';
import range from "lodash/range";
import format from "date-fns/format";

//import "react-datepicker/dist/react-datepicker.css";  


const Newproject = () => {

  const { setIsDataIn } = useContext(EmailContext);
      
  const initialValues = { business_activity_sub_type: "", busines_other_details: "", business_activity_group: "", will_need_finance_radio: "",personal_statement: "", prepopulated_data_feedback: "", acceptTerms: "",
  employment_date: "",contract_list:"",ministry_fullname:"", employment_type: "", salary_scale: "", gender: "", birth_date: "", job_title: "", town: "", postal_address: "", email_address: "", cellphone_number: "", home_phone: "", ministry: "", national_id: "", surname: "", firstname: ""
  
};

const initialMinistries =  [{item_id: "", full_name: "", abbriviation: ""}];
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const formRef = useRef(null); 
  const [userPercentage, setUserPercentage] = useState(0); 
  const [isUserEditing, setIsUserEditing] = useState(false); 

  const history = useNavigate();
  const project = useContext(ProjectContext);
  const {supervisor_edit} =useParams();
 
  let dollarUSLocale = Intl.NumberFormat('en-US');
  
  const [isPrepopulatedDataIn, setIsPrepopulatedDataIn] = useState(false);
  const [userDetails, setUserDetails] = useState({});
  const [pinagareMinistries, setPinagareMinistries] = useState(initialMinistries);
  const [otherBusinessActivity, setOtherBusinessActivity] = useState("");
  const [businessActivityGroup, setBusinessActivityGroup] = useState("");
  const [acceptTermsChecked, setAcceptTermsChecked] = useState(false);

  const [startDate, setStartDate] = useState(new Date());
  const [startDate2, setStartDate2] = useState(new Date());

  const DateCustomInput = forwardRef(({ value, onChange, onClick }, ref) => (
    
    <Input onClick={onClick} onChange={onChange} ref={ref} name='employment_date' className="form-control input_bodara" type="text" value={value} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} />
               
  ));

  const DateCustomInput2 = forwardRef(({ value, onChange, onClick }, ref) => (
    
    <Input onClick={onClick} onChange={onChange} ref={ref} name='birth_date' className="form-control input_bodara" type="text" value={value} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} />
               
  ));

  const years = range(1955, getYear(new Date()) + 1, 1);
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  
  const [business_activity_sel1, setBusinesActivitySel1] = useState("");
  const [business_activity_sel2, setBusinesActivitySel2] = useState("");
  const [business_activity_sel3, setBusinesActivitySel3] = useState("");

  const init_business_activity_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:""};

  const init_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
  ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};

  const [businesActivitySubSel, setBusinesActivitySubSel] = useState(init_business_activity_sub_sel);
  const [businesActivitySubSel2, setBusinesActivitySubSel2] = useState(init_business_activity_sub_sel);
  const [businesActivitySel, setBusinesActivitySel] = useState(init_business_activity_sel);

 
  var thisUserScore=0;
  //var userPercentage= 0;
  //var thisUserAmount=0;
  //var userPercentagePS= 0;
  //var thisUserAmountPS=0; 

  function previewApplication(){

if(isUserEditing){
 // localStorage.setItem('supervisor_edit_application',JSON.stringify(formValues));
}
else{
   // localStorage.setItem('supervisor_edit_application',JSON.stringify(userDetails));
  }
  //alert(JSON.stringify(userDetails));
  localStorage.setItem('supervisor_edit_application',JSON.stringify(userDetails));

    history(`${process.env.PUBLIC_URL}/dpsm/scheme/application/ltp/application_confirm`);
    
  }

 // localStorage.setItem('supervisor_edit_application',JSON.stringify(userDetails));

 function dateToYMD(date) {
  var d = date.getDate();
  var m = date.getMonth() + 1;
  var y = date.getFullYear();
  return '' + y + '-' + (m<=9 ? '0' + m : m) + '-' + (d <= 9 ? '0' + d : d);
}

  const handleDateChange = (value) => {
    setStartDate(value);//format(date, "yyyy-MM-dd", { awareOfUnicodeTokens: true })//toISOString  toLocaleDateString 
    setFormValues({ ...formValues, ["employment_date"]: dateToYMD(value) });
    setUserDetails({ ...userDetails, ["employment_date"]: dateToYMD(value) }); 
  };

  const handleDateChange2 = (value) => {//alert("-"+value+"-"+dateToYMD(value));
    setStartDate2(value);
    setFormValues({ ...formValues, ["birth_date"]: dateToYMD(value) });
    setUserDetails({ ...userDetails, ["birth_date"]: dateToYMD(value) }); 
  };

  const handleChange = (e) => {

    const { name, value } = e.target;
   
    setIsUserEditing(true);

    localStorage.removeItem("review_application_errors");

    if(e.target.name=="acceptTerms"){//e.target.checked
      //setAacceptTermsHandler(e.target.value);
      //alert(e.target.checked);

      if(e.target.checked){
        setFormValues({ ...formValues, [name]: value });
        setAcceptTermsChecked(true);
        delete formErrors.acceptTerms;
        setFormErrors(formErrors);
        setUserDetails({ ...userDetails, [name]: value });
      }
      else{
        setFormValues({ ...formValues, [name]: "" });
        setAcceptTermsChecked(false);
      }

      }
      else {   //alert(e.target.name); 
         
         setFormValues({ ...formValues, [name]: value });
         setUserDetails({ ...userDetails, [name]: value });
         
         if(name=='ministry'){
          
          pinagareMinistries.map((ministry) => (
            
              
            value==ministry.item_id? setUserDetails({ ...userDetails, ["ministry_full_name"]: ministry.full_name }):""
           
             ))
         }

         let parame=e.target.name;
         if (formErrors[parame]!=undefined&&formErrors[parame]!=null) delete formErrors[parame];
         setFormErrors(formErrors);
      }
      //alert(" --- "+JSON.stringify(formValues));
      
  };

  if(supervisor_edit=="onbehalf"){
    localStorage.setItem("is_onbehalf_application","true");
  }else{
    if(localStorage.getItem("is_onbehalf_application")!=null) localStorage.removeItem("is_onbehalf_application");
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    //setFormErrors(validate(formValues));
    setFormErrors(validate(userDetails));

    if(supervisor_edit=="application_confirm"){//alert(" --ok--"+JSON.stringify(userDetails));
      localStorage.setItem("review_application_errors",JSON.stringify(validate(userDetails)));
    }else{
      localStorage.removeItem("review_application_errors");
    }

    setIsSubmit(true);
  };

  useEffect(() => {

    
   
    if(Object.keys(formErrors).length !== 0){ 
      //console.log("We have errors: "+JSON.stringify(formErrors));
    }
    else{
      //console.log("No errors at all: "+JSON.stringify(formErrors));
    }

    if (Object.keys(formErrors).length === 0 && isSubmit) {
      
      if(supervisor_edit=="edit"){

        setFormValues({ ...formValues, ['scheme_application_id']: userDetails.scheme_application_id });
        //setUserDetails({ ...pre_user_data, ["ministry"]: pre_user_data.ministry_item_id });

        const body_t=JSON.stringify({
        
          omang:localStorage.getItem('username'),
          scheme_application:formValues, 
          eng:'update_pinagare_scheme_application',    
          
        });

        trackPromise(
          pinagareFetchRequest(pinagareAPIURL,body_t,'update_pinagare_scheme_application')
        ); 

      }
      else{
        
      thisUserScore=diraCalculateApplicantScore(userDetails);//alert("submission score: "+thisUserScore+"--"+Math.round((thisUserScore/75)*100));
      setUserPercentage(Math.round((thisUserScore/75)*100));

       setFormValues({ ...formValues, ['assessment_score']: Math.round((thisUserScore/75)*100), ['busines_other_details']: otherBusinessActivity });
       setUserDetails({ ...userDetails, ['assessment_score']: Math.round((thisUserScore/75)*100), ['busines_other_details']: otherBusinessActivity });


       let mohuta='';
       if(supervisor_edit=="onbehalf")mohuta='onbehalf';
       else mohuta='';

       const body_t=JSON.stringify({
        
        omang:localStorage.getItem('username'),
        mohuta:mohuta,
        scheme_application:userDetails, 
        eng:'submit_pinagare_scheme_application',    
        
      });

      trackPromise(
        pinagareFetchRequest(pinagareAPIURL,body_t,'submit_pinagare_scheme_application')
      ); 

    }

    }else {
      
      if (Object.keys(formErrors).length > 0 && isSubmit) {
          toast.error("Please fill all the required fields. There are errors in your form.");
      }
      
    }
  }, [formErrors]);

  
  const validate = (values) => {//alert('validate');
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;


    if (1==9) {
      errors.personal_statement = "Personal motivation is required!";
    }else if (2==0) {
      errors.personal_statement = "Your personal motivation is too short. Write at least 40 characters!";
    }

    if (!values.email_address) {
      errors.email_address = "Email is required!";
    } else if (!regex.test(values.email_address)) {
      errors.email_address = "This is not a valid email format!";
    }

    if (!values.job_title) {
      errors.job_title = "You must enter the job title.";
    }

    if (!values.postal_address) {
      errors.postal_address = "You must enter the postal address.";
    }

    if (!values.cellphone_number) {
      errors.cellphone_number = "You must enter the cellphone number.";
    }

    
    if (!values.surname) {
      errors.surname = "You must enter the surname.";
    }

    if (!values.birth_date) {
      errors.birth_date = "You must enter the birthdate.";
    }

    if (!values.gender) {
      errors.gender = "You must enter the gender.";
    }
    if (!values.salary_scale) {
      errors.salary_scale = "You must enter the salary scale.";
    }
    if (!values.employment_type) {
      errors.employment_type = "You must enter employment type (Contract or Permanent & Pensionable)";
    }
    if (!values.employment_date) {
      errors.employment_date = "You must enter date of first employment.";
    }
    if (!values.birth_date) {
      errors.birth_date = "You must enter the date of birth.";
    }
    
    
    if (!values.town||values.town==''||values.town==null) {
      errors.town = "You must enter the Duty Station.";
    }
    if (!values.ministry) {
      errors.ministry = "You must enter the Ministry.";
    }
    if (!values.firstname) {
      errors.firstname = "You must enter the firstname.";
    }

    
    if(supervisor_edit!="edit"){

        

    if (!values.business_activity_sub_type) {
      errors.business_activity_sub_type = "Please select or type the category of business/investment.";
    }

    
    if (!values.business_activity_group) {
      errors.business_activity_group = "Please select the type of activity you intend to venture into.";
    }

    if (!values.acceptTerms) {
      errors.acceptTerms = "You must accept Terms & Conditions.";
    }
  }
      
    return errors;
  };

  //Other

  


  function calculateAgeOrEmployementDuration(date) {//dd-mm-yyyy || yyyy-mm-dd
   // alert(date+'---- employement duration');
   if(date!=undefined&&date!=null&&date.indexOf("-")!=-1) {
    var formattedDate = date.split("-");
    var birthdateTimeStamp = new Date(formattedDate[0], formattedDate[1], formattedDate[2]);
    var currentDate = new Date().getTime();
    var difference = currentDate - birthdateTimeStamp;
    var currentAge = Math.floor(difference / 31557600000);
    // dividing by 1000*60*60*24*365.25
    return currentAge;
     //var age = diraCalculateApplicantScore('25-11-1993');
   }
   else return '0';

  }

  function fixDateBw(old_date){

    if(old_date!=undefined&&old_date!=null&&old_date.indexOf("-")!=-1) {

    var formattedDate = old_date.split("-");
    let this_month='';
    let dateIsCorrect=false;

    if(formattedDate[1]==='JAN') this_month='01';
    else if(formattedDate[1]==='FEB') this_month='02';
    else if(formattedDate[1]==='MAR') this_month='03';
    else if(formattedDate[1]==='APR') this_month='04';
    else if(formattedDate[1]==='MAY') this_month='05';
    else if(formattedDate[1]==='JUN') this_month='06';
    else if(formattedDate[1]==='JUL') this_month='07';
    else if(formattedDate[1]==='AUG') this_month='08';
    else if(formattedDate[1]==='SEP') this_month='09';
    else if(formattedDate[1]==='OCT') this_month='10';
    else if(formattedDate[1]==='NOV') this_month='11';
    else if(formattedDate[1]==='DEC') this_month='12';
    else {
      //this_month=formattedDate[1];
      dateIsCorrect=true;
    }

    if(dateIsCorrect){
           return old_date;
    }
    else{
          return formattedDate[2]+"-"+this_month +"-"+ formattedDate[0];
      }
    }
    else return "0000-00-00";

  }
  
 

  function diraCalculateApplicantScore(user){//alert(JSON.stringify(user.birth_date)+'---- birth @ applicant score');

    var total_employee_score,age_score,service_years_score,employment_type_score=0;
    var age = calculateAgeOrEmployementDuration(fixDateBw(user.birth_date));
    var employement_type= user.employement_type;
    var years_employed = calculateAgeOrEmployementDuration(fixDateBw(user.employment_date));

    if(employement_type!=null&&(employement_type.indexOf("contract")!=-1||employement_type.indexOf("Contract")!=-1||employement_type.indexOf("CONTRACT")!=-1)){
      employement_type='contract';
    }
    else{
      employement_type='P&P';
    }

    //calculate age_score
    if(age <=50) age_score=10;
    else if(age >=51 && age <=54) age_score=20;
    else if(age >=55 && age <=57) age_score=30;
    else if(age >=58 && employement_type==='contract') age_score=40;
    else if(age >=58 && employement_type!='contract') age_score=0;
    else age_score=0;

    //calculate service_years_score
    if(years_employed < 3) service_years_score=5;
    else if(years_employed >= 3 && years_employed <= 5) service_years_score=10;
    else if(years_employed > 5 && years_employed <= 8) service_years_score=15;
    else if(years_employed > 8 ) service_years_score=20;    
    
    //calculate employement_type_score
    if(employement_type==='contract') employment_type_score=4;
    else employment_type_score=6;
   
    total_employee_score = age_score+service_years_score+employment_type_score;

    //alert("age_score:"+age_score+"/"+age+"--"+user.birth_date+", service_years_score:"+service_years_score+", employment_type_score:"+employment_type_score);

    return Math.round(total_employee_score);

   }

   function diraCalculateApplicantAmount(score){

    var indicative_amount=0;
    
    if(score < 60) indicative_amount=0;
    else if(score >=60 && score <=65) indicative_amount=1500000;
    else if(score >=65 && score <=70) indicative_amount=1700000;
    else if(score >=70 && score <=75) indicative_amount=1900000;
    else if(score >=75 && score <=80) indicative_amount=2100000;
    else if(score >=80 && score <=85) indicative_amount=2500000;
    else if(score >=85 && score <=90) indicative_amount=3000000;
    else if(score >=90 && score <=95) indicative_amount=4000000;
    else if(score >=95 ) indicative_amount=5000000;
    else indicative_amount=0;

    return dollarUSLocale.format(indicative_amount, {
      style: "currency",
      currency: "BWP",
      useGrouping: true,
      maximumSignificantDigits: 2,
  });

   }

  useEffect(() => {

   

    if(!isPrepopulatedDataIn){
    
      const body_t=JSON.stringify({
        
        omang:localStorage.getItem('username'),
        eng:'fetch_pinagare_scheme_user',       
        
      });

      if(supervisor_edit=="edit"||supervisor_edit=="application_confirm"||supervisor_edit=="correct_application"){

        let pre_user_data=JSON.parse(localStorage.getItem('supervisor_edit_application'));
        
        if(supervisor_edit=="edit"){
          trackPromise(
            pinagareFetchRequest(pinagareAPIURL,body_t,'fetch_pinagare_scheme_user')
          ); 

          setUserDetails({ ...pre_user_data, ["ministry"]: pre_user_data.ministry_item_id }); 
          setUserDetails({ ...pre_user_data, ["ministry_full_name"]: pre_user_data.ministry });
        }
        else{
          setUserDetails(pre_user_data); 
        }
          

          setStartDate(new Date(fixDateBw(pre_user_data.employment_date)));
          setStartDate2(new Date(fixDateBw(pre_user_data.birth_date)));
                            
       

        if(supervisor_edit=="correct_application"){//alert(JSON.stringify(pre_user_data));

          
          
          if (pre_user_data.acceptTerms!=undefined&&pre_user_data.acceptTerms != '') {

            setAcceptTermsChecked(true);
            delete formErrors.acceptTerms;
            setFormErrors(formErrors);

          }

           if (pre_user_data.business_activity_group!=undefined&&pre_user_data.business_activity_group != '') {

              //setFormValues({ ...formValues, ['business_activity_group']: pre_user_data.business_activity_group});
              
              //const updatedFormValues = {...formValues, ['business_activity_group']: pre_user_data.business_activity_group};
              //setFormValues(updatedFormValues); 

             
              
              //setUserDetails({ ...userDetails, ["business_activity_group"]: pre_user_data.business_activity_group }); 
             // alert(formValues.business_activity_group+"--"+pre_user_data.business_activity_group+" --- "+JSON.stringify(formValues));

                 //setUserDetails({ ...userDetails, ["business_activity_group"]: pre_user_data.business_activity_group}); 

                 let this_business_activity_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:""};

              if (pre_user_data.business_activity_group === 'business') {
        
              setIsBusinessVisible(true);
              setIsInvestmentVisible(false);
              setIsOtherVisible(true);
              setOtherBusinessActivity(pre_user_data.business_activity_sub_type);

              
              this_business_activity_sel={ ba_sub_sel1:"",ba_sub_sel2:"selected",ba_sub_sel3:""};

              if (pre_user_data.business_activity_sub_type!=undefined&&pre_user_data.business_activity_sub_type != '') {
                

                //setFormValues({ ...formValues, ["business_activity_sub_type"]: pre_user_data.business_activity_sub_type});
                //alert(formValues.business_activity_sub_type);
                let this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                    ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
                    
                  
                  if (pre_user_data.business_activity_sub_type === 'Mining and Exploration'){
                          

                   this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"selected",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                   ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
  
 
               
                  }
                 else if (pre_user_data.business_activity_sub_type === 'Tourism and Hospitality'){
          
                
                  this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"selected",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                  ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                  } 
                  else if (pre_user_data.business_activity_sub_type === 'Agriculture and Agribusiness'){
          
                
                   this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"selected",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                  ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                  } 
                  else if (pre_user_data.business_activity_sub_type === 'Manufacturing and Industrialization'){
          
                
                    this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"selected",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                    ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                  } 
                  else if (pre_user_data.business_activity_sub_type === 'Infrastructure Development'){
          
                
                    this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"selected",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                   ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                 } 
                  else if (pre_user_data.business_activity_sub_type === 'Information and Communication Technology (ICT)'){
          
                
                  this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"selected",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                  ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                  } 
                  else if (pre_user_data.business_activity_sub_type === 'Financial Services'){
                          
                  this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"selected",ba_sub_sel9:"",ba_sub_sel10:""
                  ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                 } 
                 else if (pre_user_data.business_activity_sub_type === 'Renewable Energy'){
                          
                  this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"selected",ba_sub_sel10:""
                  ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                  } 
                  else if (pre_user_data.business_activity_sub_type === 'Real Estate and Property Development'){
                          
                   this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:"selected"
                   ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                   } 
                  else if (pre_user_data.business_activity_sub_type === 'Education and Training'){
                          
                   this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                  ,ba_sub_sel11:"selected",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                  } 
                
                else if (pre_user_data.business_activity_sub_type === 'Other'){
                          
                 this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                 ,ba_sub_sel11:"",ba_sub_sel12:"selected",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                } 
               else {
          
                    this_business_activity_sub_sel={ ba_sub_sel1:"selected",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                   ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                 }
              
                setBusinesActivitySubSel2(this_business_activity_sub_sel);
  
            }
            else{

                setIsOtherVisible(false);

               let t_business_activity_sub_sel={ ba_sub_sel1:"selected",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
                setBusinesActivitySubSel2(t_business_activity_sub_sel);


               // setFormValues({ ...formValues, ["business_activity_sub_type"]: "" });
            }


             
        
              } else if (pre_user_data.business_activity_group === 'investment'){
        
              setIsBusinessVisible(false);
              setIsInvestmentVisible(true);
              setIsOtherVisible(true);
              setOtherBusinessActivity(pre_user_data.business_activity_sub_type);

              
              this_business_activity_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"selected"};

              if (pre_user_data.business_activity_sub_type!=undefined&&pre_user_data.business_activity_sub_type != '') {

               // setFormValues({ ...formValues, ["business_activity_sub_type"]: pre_user_data.business_activity_sub_type});

                let this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                    ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};

                  
                  if (pre_user_data.business_activity_sub_type === 'Bonds'){
                          

                   this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"selected",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                   ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
  
 
               
                  }
                 else if (pre_user_data.business_activity_sub_type === 'Wealth Fund Investments'){
          
                
                  this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"selected",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                  ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                  } 
                  else if (pre_user_data.business_activity_sub_type === 'Fixed-Income Funds'){
          
                
                   this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"selected",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                  ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                  } 
                  else if (pre_user_data.business_activity_sub_type === 'Stocks'){
          
                
                    this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"selected",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                    ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                  } 
                  else if (pre_user_data.business_activity_sub_type === 'Exchange-Traded Funds (ETFs)'){
          
                
                    this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"selected",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                   ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                 } 
                  else if (pre_user_data.business_activity_sub_type === 'Real Estate Investment Trusts (REITs)'){
          
                
                  this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"selected",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                  ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                  } 
                  else if (pre_user_data.business_activity_sub_type === 'Money Market Instruments'){
                          
                  this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"selected",ba_sub_sel9:"",ba_sub_sel10:""
                  ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                 } 
                 else if (pre_user_data.business_activity_sub_type === 'Unit Trusts/Mutual Funds'){
                          
                  this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"selected",ba_sub_sel10:""
                  ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                  } 
                  else if (pre_user_data.business_activity_sub_type === 'Private Equity'){
                          
                   this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:"selected"
                   ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                   } 
                  else if (pre_user_data.business_activity_sub_type === 'Hedge Funds'){
                          
                   this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                  ,ba_sub_sel11:"selected",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                  } 
                 else if (pre_user_data.business_activity_sub_type === 'Commodities'){
                          
                  this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                  ,ba_sub_sel11:"",ba_sub_sel12:"selected",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                 } 
                 else if (pre_user_data.business_activity_sub_type === 'Foreign Exchange (Forex)'){
                          
                   this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                  ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"selected",ba_sub_sel14:"",ba_sub_sel15:""};
               
                 } 
                 else if (pre_user_data.business_activity_sub_type === 'Cryptocurrencies'){
                          
                  this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                  ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"selected",ba_sub_sel15:""};
               
                 } 
                else if (pre_user_data.business_activity_sub_type === 'Other'){
                          
                 this_business_activity_sub_sel={ ba_sub_sel1:"",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                 ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:"selected"};
               
                } 
               else {
          
                    this_business_activity_sub_sel={ ba_sub_sel1:"selected",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                   ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
               
                 }
              
                setBusinesActivitySubSel(this_business_activity_sub_sel);
                //setFormValues({ ...formValues, ["business_activity_sub_type"]: pre_user_data.business_activity_sub_type});
            }
            else{

                setIsOtherVisible(false);

               let t_business_activity_sub_sel={ ba_sub_sel1:"selected",ba_sub_sel2:"",ba_sub_sel3:"",ba_sub_sel4:"",ba_sub_sel5:"",ba_sub_sel6:"",ba_sub_sel7:"",ba_sub_sel8:"",ba_sub_sel9:"",ba_sub_sel10:""
                ,ba_sub_sel11:"",ba_sub_sel12:"",ba_sub_sel13:"",ba_sub_sel14:"",ba_sub_sel15:""};
                setBusinesActivitySubSel(t_business_activity_sub_sel);


              //  setFormValues({ ...formValues, ["business_activity_sub_type"]: "" });
            }

           // setFormValues({ ...formValues, ["business_activity_sub_type"]: pre_user_data.business_activity_sub_type});

                           
            }
            else{
              this_business_activity_sel={ ba_sub_sel1:"selected",ba_sub_sel2:"",ba_sub_sel3:""};
            }

            setBusinesActivitySel(this_business_activity_sel);
            //setFormValues({ ...formValues, ["business_activity_group"]: pre_user_data.business_activity_group, ["business_activity_sub_type"]: pre_user_data.business_activity_sub_type});
            //setFormValues({ ...formValues, ["business_activity_sub_type"]: pre_user_data.business_activity_sub_type});
            setOtherBusinessActivity(pre_user_data.business_activity_sub_type);


         }
            else{
              setIsOtherVisible(false);
              setIsBusinessVisible(false);
              setIsInvestmentVisible(false);

              setBusinesActivitySel1("selected");
              setBusinesActivitySel2("");
              setBusinesActivitySel3("");
              let this_business_activity_sel={ ba_sub_sel1:"selected",ba_sub_sel2:"",ba_sub_sel3:""};
              setBusinesActivitySel(this_business_activity_sel);
              //setFormValues({ ...formValues, ["business_activity_group"]: "", ["business_activity_sub_type"]: "" });
              //setFormValues({ ...formValues, ["business_activity_sub_type"]: "" });
            }
        
             setFormValues({ ...formValues, ["prepopulated_data_feedback"]: pre_user_data.prepopulated_data_feedback,["acceptTerms"]: pre_user_data.acceptTerms, ["business_activity_group"]: pre_user_data.business_activity_group, ["business_activity_sub_type"]: pre_user_data.business_activity_sub_type,['employment_date']: pre_user_data.employment_date,['employment_type']: pre_user_data.employment_type,['salary_scale']: pre_user_data.salary_scale, ['gender']: pre_user_data.gender, ['birth_date']: pre_user_data.birth_date, ['job_title']: pre_user_data.job_title, ['town']: pre_user_data.town, ['postal_address']: pre_user_data.postal_address, ['email_address']: pre_user_data.email_address, ['cellphone_number']: pre_user_data.cellphone_number, ['home_phone']: pre_user_data.home_phone, ['ministry']: pre_user_data.ministry, ['national_id']: pre_user_data.national_id, ['surname']: pre_user_data.surname, ['firstname']: pre_user_data.firstname, ['contract_list']: pre_user_data.contract_list, ['assessment_score']: pre_user_data.assessment_score, ['scheme_application_id']: pre_user_data.scheme_application_id  });
             //setFormErrors(validate(formValues));
             if(localStorage.getItem("review_application_errors")!=null) setFormErrors(JSON.parse(localStorage.getItem("review_application_errors")));
             //else 
             //alert("hooray: "+localStorage.getItem("review_application_errors"));
             localStorage.removeItem("review_application_errors");
        

        }//if correct_application
        //else alert("fire: "+supervisor_edit);

        setIsPrepopulatedDataIn(true);
      }
      else{//alert(supervisor_edit);
             trackPromise(
                  pinagareFetchRequest(pinagareAPIURL,body_t,'fetch_pinagare_scheme_user')
            );  
      }
  
    }else{

      thisUserScore=diraCalculateApplicantScore(userDetails);
      setUserPercentage(Math.round((thisUserScore/75)*100));

       //setFormValues({ ...formValues, ['assessment_score']: Math.round((thisUserScore/75)*100), ['busines_other_details']: otherBusinessActivity });
       
       setUserDetails({ ...userDetails, ['prepopulated_data_feedback']: userDetails.prepopulated_data_feedback, ['employment_date']: userDetails.employment_date,['employment_type']: userDetails.employment_type,['salary_scale']: userDetails.salary_scale, ['gender']: userDetails.gender, ['birth_date']: userDetails.birth_date, ['job_title']: userDetails.job_title, ['town']: userDetails.town, ['postal_address']: userDetails.postal_address, ['email_address']: userDetails.email_address, ['cellphone_number']: userDetails.cellphone_number, ['home_phone']: userDetails.home_phone, ['ministry']: userDetails.ministry, ['national_id']: userDetails.national_id, ['surname']: userDetails.surname, ['firstname']: userDetails.firstname, ['contract_list']: userDetails.contract_list, ['assessment_score']: Math.round((thisUserScore/75)*100), ['scheme_application_id']: userDetails.scheme_application_id  });
    
     
      setFormValues({ ...formValues, ['prepopulated_data_feedback']: userDetails.prepopulated_data_feedback, ['employment_date']: userDetails.employment_date,['employment_type']: userDetails.employment_type,['salary_scale']: userDetails.salary_scale, ['gender']: userDetails.gender, ['birth_date']: userDetails.birth_date, ['job_title']: userDetails.job_title, ['town']: userDetails.town, ['postal_address']: userDetails.postal_address, ['email_address']: userDetails.email_address, ['cellphone_number']: userDetails.cellphone_number, ['home_phone']: userDetails.home_phone, ['ministry']: userDetails.ministry, ['national_id']: userDetails.national_id, ['surname']: userDetails.surname, ['firstname']: userDetails.firstname, ['contract_list']: userDetails.contract_list, ['assessment_score']: Math.round((thisUserScore/75)*100), ['scheme_application_id']: userDetails.scheme_application_id  });
    
    }

      
  }, [isPrepopulatedDataIn]);


  async function pinagareFetchRequest(url,body,eng) {
    try {
      await fetch(url, {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: body,
      })
        .then((response) => {
          if (response.ok) {
           
            return response.json()
          }
          else {
            //alert('Error found: '+JSON.stringify(response));
            return response.text().then(text => { throw new Error(text) })
            //throw new Error(respose);
          }
        })
        .then((data) => {//alert('kk');

         
          if (data.status!=null&&data.status==true&&data.status!=undefined) {

            if(data.applicationPeriodEnded!==null&&data.applicationPeriodEnded!==undefined&&data.applicationPeriodEnded){
              toast.error("Applications are not yet open for this programme...");
              history(`${process.env.PUBLIC_URL}/dpsm/scheme/ltp`);                
            }//else alert('bingo');


            if(data.eng=='fetch_pinagare_scheme_user'&&data.eng!=null){
              
              if(data.userEligible==null||data.userEligible==undefined||!data.userEligible){
                toast.error("This programme is NOT available for your benefit...");
                history(`${process.env.PUBLIC_URL}/dpsm/scheme/ltp`);                
              }//else toast.success("User is eligible to apply for the programme...");

              if(data.pinagareMinistries!==null&&data.pinagareMinistries!==undefined){
                setPinagareMinistries(data.pinagareMinistries);
              }

              if(supervisor_edit=="onbehalf"){

                const initialValues = { business_activity_sub_type: "", busines_other_details: "", business_activity_group: "", will_need_finance_radio: "",personal_statement: "", prepopulated_data_feedback: "", acceptTerms: "",
                prepopulated_data_feedback:"", employment_date: "",contract_list:"", employment_type: "", salary_scale: "", gender: "", birth_date: "", job_title: "", town: "", postal_address: "", email_address: "", cellphone_number: "", home_phone: "", ministry: "", national_id: "", surname: "", firstname: ""
              };
              
              setUserDetails(initialValues); 
      
              }

            if(!data.userHasApplied){

              if(supervisor_edit!="onbehalf"&&supervisor_edit!="edit") {

              const updatedUserDetails = {...data.user, prepopulated_data_feedback:'', personal_statement: '', business_activity_group: '', business_activity_sub_type: '',  acceptTerms: ''};

              setUserDetails(updatedUserDetails);
                       
              setStartDate(new Date(fixDateBw(data.user.employment_date))); 
              setStartDate2(new Date(fixDateBw(data.user.birth_date))); 
             }
            //localStorage.setItem('username', data.username);
            //localStorage.setItem("Name", data.name);
            //localStorage.removeItem('username_temp');
            
              setIsPrepopulatedDataIn(true);

            //toast.success("User fetch Successful...");            
           

            }
            else{

              //localStorage.setItem('scheme_application', data.scheme_application);
             
              toast.success("User has already applied. Redirecting to Application Tracking...");
              history(`${process.env.PUBLIC_URL}/dpsm/home/my-applications`);

            }

           
          }
          else if(data.eng=='submit_pinagare_scheme_application'&&data.eng!=null){
            
            setIsSubmit(false);
            setIsDataIn(false);
            //localStorage.setItem('scheme_application', data.scheme_application); 

            toast.success("Application Submitted Successfully...");

            //toast.success("Redirecting to Application Tracking...");
            localStorage.removeItem('supervisor_edit_application');

            if(supervisor_edit=="onbehalf"||(localStorage.getItem("is_onbehalf_application")!=null&&localStorage.getItem("is_onbehalf_application")=="true")){

              history(`${process.env.PUBLIC_URL}/dpsm/supervisor-tasks`);
              localStorage.removeItem("is_onbehalf_application");
            }
            else{
              history(`${process.env.PUBLIC_URL}/dpsm/home/my-applications`);
            }
            

          }
          else if(data.eng=='update_pinagare_scheme_application'&&data.eng!=null){//alert(JSON.stringify(data.scheme_application));
            
            setIsSubmit(false);
            setIsDataIn(false);
            
            localStorage.removeItem('supervisor_edit_application'); 

            history(`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+userDetails.scheme_application_id);
            toast.success("Application edited successfully...");

          }
          else{
            //alert('Testing..');
          }

            //history(`${process.env.PUBLIC_URL}/dpsm/home`);

            //console.log('fetch success 1-----');

                          
          } else {

            

            if(data.eng=='fetch_pinagare_scheme_user'&&data.eng!=undefined){
              
              //if(data.userEligible==null||!data.userEligible){
                toast.error("User is NOT eligible for the programme... Or Data fetch error. Redirecting.");
                history(`${process.env.PUBLIC_URL}/dpsm/scheme/ltp`);                
             // }else toast.success("User is eligible to apply for programme...");

            } else if (data.status!=null&&data.status==false&&data.message!=undefined) {
              toast.error(data.message);
            }
            else{
              toast.error("Data Submit error occurred..."+JSON.stringify(data));
            }
                        
            if(eng=='submit_pinagare_scheme_application'){
              setIsSubmit(false);
              setIsPrepopulatedDataIn(false);
            }

          }
        }).catch ((error) => {//alert(error);
          // Your error is here!
          console.log(error)
        });
    } catch (error) {//alert('failed');
     
      if(eng=='fetch_pinagare_scheme_user'){
              
       
          toast.error("User is NOT eligible for the programme... Or Data fetch error. Redirecting.");
           

         } 
      else {
        toast.error("Making Data  Request failed..."+JSON.stringify(error));
      }
      //history(`${process.env.PUBLIC_URL}/dpsm/scheme/ltp`);
      //if(eng=='submit_pinagare_scheme_application'){
        setIsSubmit(false);
        setIsPrepopulatedDataIn(false);
      //}
      

    }
  }

  
  const [isOtherVisible, setIsOtherVisible] = useState(false);
  const [isBusinessVisible, setIsBusinessVisible] = useState(false);
  const [isInvestmentVisible, setIsInvestmentVisible] = useState(false);

  const selectChangeHandler = (e,eng) => { 
    //alert(document.querySelector("#busines_other_details"));

    localStorage.removeItem("review_application_errors");

    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });

        
    const updatedUserDetails1 = {...userDetails, [name]: value};
    setUserDetails(updatedUserDetails1); 

    if(eng==='main'||e.target.name === 'business_activity_group'){//alert(formValues.business_activity_group+"--"+e.target.value);

      delete formErrors.business_activity_group;
      setFormErrors(formErrors);

    if (e.target.value === 'business') {

      setIsBusinessVisible(true);
      setIsInvestmentVisible(false);
      setIsOtherVisible(false);

    } else if (e.target.value === 'investment'){

      setIsBusinessVisible(false);
      setIsInvestmentVisible(true);
      setIsOtherVisible(false);
     
    }
    else{
      setIsOtherVisible(false);
      setIsBusinessVisible(false);
      setIsInvestmentVisible(false);
    }

    setOtherBusinessActivity("");

     }

    else {

      setIsOtherVisible(true);

       if(otherBusinessActivity=="") {//busines_other_details
        
        setOtherBusinessActivity(e.target.value);
        //alert(e.target.name+" 1 "+otherBusinessActivity);
       }
       else {
        setOtherBusinessActivity(e.target.value);
        //alert(e.target.name+" 2 "+otherBusinessActivity);
       }
     
       delete formErrors.business_activity_sub_type;
       setFormErrors(formErrors);   
      
    }

  };


  
  if(userDetails != null && userDetails.birth_date !==null){ 
   // var thisUser={employement_type:'contract',employment_date:'2010-06-22', birth_date:'1967-11-18'};
   //thisUserScore=diraCalculateApplicantScore(userDetails);
   //setUserPercentage(Math.round((thisUserScore/75)*100));
   //userPercentage= Math.round((thisUserScore/75)*100);
   //thisUserAmount=diraCalculateApplicantAmount(userPercentage);

   

   //userPercentagePS= Math.round(((thisUserScore+5)/75)*100);
   //thisUserAmountPS=diraCalculateApplicantAmount(userPercentagePS);

  //const login = useState(JSON.parse(localStorage.getItem("login")))[0];
  }

  return (
    <Fragment>
      <Breadcrumbs parent='Home' title='Programme Application' mainTitle='Leadership Transformation Programme' />
      <Container fluid={true}>
      
        <Row>
          <Col sm='12'>
		  
            <Card>
			
              <CardBody>

    {/*<Form className='theme-form' onSubmit={handleSubmit(SubmitApplication)}> */}

    <Form className='theme-form' onSubmit={handleSubmit}> 
			  
			  <H5>{"APPLICATION FORM" + (supervisor_edit=="edit"? " (Edited by a Supervisor)" : "")}</H5>
			  <hr />
			  
			 {supervisor_edit=="application_confirm"? (null):(userDetails != null && Object.keys(userDetails).length !== 0? 

       (<div><Row>
        <Col sm='6'>		  
			  <H6>
           <p><Label style={{fontSize:'16px'}}>{"Name:"}</Label>
                <Input onChange={handleChange} name='firstname' className="form-control input_bodara" type="text" value={userDetails.firstname} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}}  />
                <span style={{ color: 'red' }}>{formErrors.firstname}</span>	
        </p>
        <p><Label  style={{fontSize:'16px'}}>{"Surname:"}</Label>
                <Input onChange={handleChange} name='surname' className="form-control input_bodara" type="text" value={userDetails.surname} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}}  />
                <span style={{ color: 'red' }}>{formErrors.surname}</span>
        </p>
			  <p><Label  style={{fontSize:'16px'}}>{"ID Number:"}</Label>
            {supervisor_edit=="onbehalf"?   ( <Input onChange={handleChange} name='national_id' className="form-control input_bodara" type="text" value={userDetails.national_id} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}}  />
            ):(<Input onChange={handleChange} name='national_id' className="form-control input_bodara" type="text" value={userDetails.national_id} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} disabled  />
          )}
          <span style={{ color: 'red' }}>{formErrors.national_id}</span>
			  </p>
        <p><Label  style={{fontSize:'16px'}}>{"Ministry/Independent Department:"} </Label>
              {/*}  <Input onChange={handleChange} name='ministry' className="form-control input_bodara" type="text" value={userDetails.ministry} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} />
               */}

            <select onChange={(e) => {handleChange(e)}}  className='form-control input_bodara' name="ministry"  style={{ border:'1px solid #6ec6ec'}}>
              <option value="">{"Select"}</option>
              { pinagareMinistries.map((ministry) => (
            
              
                userDetails.ministry==ministry.item_id? <option value={ministry.item_id} selected="selected">{ministry.full_name}</option> :<option value={ministry.item_id} >{ministry.full_name}</option>
              
       
     
                 ))}
             </select>
             <span style={{ color: 'red' }}>{formErrors.ministry}</span>
        </p>
        <p><Label  style={{fontSize:'16px'}}>{"Home Phone:"}</Label>
                <Input onChange={handleChange} name='home_phone' className="form-control input_bodara" type="text" value={userDetails.home_phone} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} />
                <span style={{ color: 'red' }}>{formErrors.home_phone}</span>	
        </p>
        <p><Label  style={{fontSize:'16px'}}>{"Cellphone Number:"}</Label>
                <Input onChange={handleChange} name='cellphone_number' className="form-control input_bodara" type="text" value={userDetails.cellphone_number} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} />
                <span style={{ color: 'red' }}>{formErrors.cellphone_number}</span>
        </p>
        <p><Label  style={{fontSize:'16px'}}>{"Email Address:"}</Label>
                <Input onChange={handleChange} name='email_address' className="form-control input_bodara" type="text" value={userDetails.email_address} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} />
                <span style={{ color: 'red' }}>{formErrors.email_address}</span>
        </p>
        <p><Label  style={{fontSize:'16px'}}>{"Postal Address:"}</Label>
                <Input onChange={handleChange} name='postal_address' className="form-control input_bodara" type="text" value={userDetails.postal_address} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} />
                <span style={{ color: 'red' }}>{formErrors.postal_address}</span>
        </p>
			 
			  </H6>			  
			  </Col>			  
			  <Col sm='6'>		  
			  <H6>
        <p><Label  style={{fontSize:'16px'}}>{"Duty Station:"}</Label>
                <Input onChange={handleChange} name='town' className="form-control input_bodara" type="text" value={userDetails.town} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}}  />
                <span style={{ color: 'red' }}>{formErrors.town}</span>	
        </p>
        <p><Label  style={{fontSize:'16px'}}>{"Position:"}</Label>
                <Input onChange={handleChange} name='job_title' className="form-control input_bodara" type="text" value={userDetails.job_title} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}}  />
                <span style={{ color: 'red' }}>{formErrors.job_title}</span>
        </p>
			  <p><Label  style={{fontSize:'16px'}}>{"Date of Birth :"}</Label>
        {supervisor_edit=="onbehalf"?   ( 
               <DatePicker customInput={<DateCustomInput2 />} name='birth_date' dateFormat="yyyy-MM-dd"
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div className="form-control react-datepicker" 
          style={{
            margin: 0,
            display: "flex",
            justifyContent: "center",
            color: "#6ec6ec !important",
          }}
        >
          <button 
          style={{
            fontWeight: "bold",            
            background: "#6ec6ec",
                }}
          className="form-control" onClick={(event)=>{event.preventDefault();decreaseMonth(event);}} disabled={prevMonthButtonDisabled}>
            {"<"}
          </button>
          <select 
            value={getYear(date)}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[getMonth(date)]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <button 
          style={{
            fontWeight: "bold",            
            background: "#6ec6ec",
                }}
          className="form-control" onClick={(event)=>{event.preventDefault();increaseMonth(event);}} disabled={nextMonthButtonDisabled}>
            {">"}
          </button>
        </div>
      )}
      selected={startDate2}
      onChange={(date) => handleDateChange2(date)}
    />
  
              
              ):(<Input onChange={handleChange} name='birth_date' className="form-control input_bodara" type="text" value={fixDateBw(userDetails.birth_date)} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} disabled />
          )}
                 <span style={{ color: 'red' }}>{formErrors.birth_date}</span>
        </p>
        <p><Label  style={{fontSize:'16px'}}>{"Gender:"}</Label>
                <Input onChange={handleChange} name='gender' className="form-control input_bodara" type="text" value={userDetails.gender} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} />
                <span style={{ color: 'red' }}>{formErrors.gender}</span>
        </p>
        <p><Label  style={{fontSize:'16px'}}>{"Salary Scale:"}</Label>
                <Input onChange={handleChange} name='salary_scale' className="form-control input_bodara" type="text" value={userDetails.salary_scale} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} />
                <span style={{ color: 'red' }}>{formErrors.salary_scale}</span>
        </p>
        <p><Label  style={{fontSize:'16px'}}>{"Employment Terms:"}</Label>
                <Input onChange={handleChange} name='employment_type' className="form-control input_bodara" type="text" value={userDetails.employment_type} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} />
                <span style={{ color: 'red' }}>{formErrors.employment_type}</span>
        </p>
        <p><Label  style={{fontSize:'16px'}}>{"Date of Joining Public Service:"}</Label>
                {/*<Input onChange={handleChange} name='employment_date' className="form-control input_bodara" aria-label="Date" type="date" value={fixDateBw(userDetails.employment_date)} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} disabled />*/}
                
                {/*<DatePicker customInput={<DateCustomInput />}   name='employment_date' dateFormat="yyyy-MM-dd" selected={startDate} onChange={(date) => handleDateChange(date)}  />*/}
                <DatePicker customInput={<DateCustomInput />} name='employment_date' dateFormat="yyyy-MM-dd"
      renderCustomHeader={({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
      }) => (
        <div className="form-control react-datepicker" 
          style={{
            margin: 0,
            display: "flex",
            justifyContent: "center",
            color: "#6ec6ec !important",
          }}
        >
          <button 
          style={{
            fontWeight: "bold",            
            background: "#6ec6ec",
                }}
          className="form-control" onClick={(event)=>{event.preventDefault();decreaseMonth(event);}} disabled={prevMonthButtonDisabled}>
            {"<"}
          </button>
          <select 
            value={getYear(date)}
            onChange={({ target: { value } }) => changeYear(value)}
          >
            {years.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <select
            value={months[getMonth(date)]}
            onChange={({ target: { value } }) =>
              changeMonth(months.indexOf(value))
            }
          >
            {months.map((option) => (
              <option key={option} value={option}>
                {option}
              </option>
            ))}
          </select>

          <button 
          style={{
            fontWeight: "bold",            
            background: "#6ec6ec",
                }}
          className="form-control" onClick={(event)=>{event.preventDefault();increaseMonth(event);}} disabled={nextMonthButtonDisabled}>
            {">"}
          </button>
        </div>
      )}
      selected={startDate}
      onChange={(date) => handleDateChange(date)}
    />
                
                <span style={{ color: 'red' }}>{formErrors.employment_date}</span>
        </p>
       
			  </H6>			  
			  </Col>
			 </Row>
        <hr />			
       </div> ) : (
       <Row>
        <Col sm='6'>			  
			  <H6>
          <p>{"User details could not be retrived!"}</p>
        </H6>			  
			  </Col>
			 </Row>
       ))}
			  
        
        {supervisor_edit=="application_confirm"? ( null ):(supervisor_edit=="edit"? "" : (
          <H6>
			   <hr />
                             
              <Row>
                <Col sm='6'> 

                 {/*} <ProjectRateClass register={register} errors={errors} />*/}

                  <FormGroup>
                       <H6> <Label>{"Type of Activity"}</Label>
                        <Input  onChange={(event) => {  selectChangeHandler(event,'main') }} style={{borderColor:'#6ec6ec !important', border:'2px solid #6ec6ec'}} type="select" name="business_activity_group" className="form-control digits" >
                            <option value="" selected={businesActivitySel.ba_sub_sel1}>{"Select"}</option>
                            <option value="business" selected={businesActivitySel.ba_sub_sel2}>{"Business"}</option>
                            <option value="investment" selected={businesActivitySel.ba_sub_sel3}>{"Investment"}</option>
                        </Input>
                        <span style={{ color: 'red' }}>{formErrors.business_activity_group}</span>
					            </H6>
                  </FormGroup>

				        </Col>
			  
			          <Col sm='6'>

                   {isBusinessVisible ? (
                        <H6> <Label>{"Business"}</Label>
                        <Input onChange={selectChangeHandler} style={{borderColor:'#6ec6ec !important', border:'2px solid #6ec6ec'}} type="select"  name="business_activity_sub_type" className="form-control digits" >
                            <option value="" selected ={businesActivitySubSel2.ba_sub_sel1}>{"Select"}</option>
                            <option value="Mining and Exploration" selected ={businesActivitySubSel2.ba_sub_sel2}>{"Mining and Exploration"}</option>
                            <option value="Tourism and Hospitality" selected ={businesActivitySubSel2.ba_sub_sel3}>{"Tourism and Hospitality"}</option>
                            <option value="Agriculture and Agribusiness" selected ={businesActivitySubSel2.ba_sub_sel4}>{"Agriculture and Agribusiness"}</option>
                            <option value="Manufacturing and Industrialization" selected ={businesActivitySubSel2.ba_sub_sel5}>{"Manufacturing and Industrialization"}</option>
                            <option value="Infrastructure Development" selected ={businesActivitySubSel2.ba_sub_sel6}>{"Infrastructure Development"}</option>
                            <option value="Information and Communication Technology (ICT)" selected ={businesActivitySubSel2.ba_sub_sel7}>{"Information and Communication Technology (ICT)"}</option>
                            <option value="Financial Services" selected ={businesActivitySubSel2.ba_sub_sel8}>{"Financial Services"}</option>
                            <option value="Renewable Energy" selected ={businesActivitySubSel2.ba_sub_sel9}>{"Renewable Energy"}</option>
                            <option value="Real Estate and Property Development" selected ={businesActivitySubSel2.ba_sub_sel10}>{"Real Estate and Property Development"}</option>
                            <option value="Education and Training" selected ={businesActivitySubSel2.ba_sub_sel11}>{"Education and Training"}</option>
                            <option value="Other" selected ={businesActivitySubSel2.ba_sub_sel12}>{"Other"}</option>
                        </Input>
                        <span style={{ color: 'red' }}>{formErrors.business_activity_sub_type}</span>
					            </H6>
                     ) : isInvestmentVisible ? (
                      <H6> <Label>{"Investment"}</Label>
                      <Input onChange={selectChangeHandler} style={{borderColor:'#6ec6ec !important', border:'2px solid #6ec6ec'}} type="select" name="business_activity_sub_type" className="form-control digits" >
                          <option value="" selected ={businesActivitySubSel.ba_sub_sel1}>{"Select"}</option>
                          <option value="Bonds" selected ={businesActivitySubSel.ba_sub_sel2}>{"Bonds"}</option>
                          <option value="Wealth Fund Investments" selected ={businesActivitySubSel.ba_sub_sel3}>{"Wealth Fund Investments"}</option>
                          <option value="Fixed-Income Funds" selected ={businesActivitySubSel.ba_sub_sel4}>{"Fixed-Income Funds"}</option>
                          <option value="Stocks" selected ={businesActivitySubSel.ba_sub_sel5}>{"Stocks"}</option>
                          <option value="Exchange-Traded Funds (ETFs)" selected ={businesActivitySubSel.ba_sub_sel6}>{"Exchange-Traded Funds (ETFs)"}</option>
                          <option value="Real Estate Investment Trusts (REITs)" selected ={businesActivitySubSel.ba_sub_sel7}>{"Real Estate Investment Trusts (REITs)"}</option>
                          <option value="Money Market Instruments" selected ={businesActivitySubSel.ba_sub_sel8}>{"Money Market Instruments"}</option>
                          <option value="Unit Trusts/Mutual Funds" selected ={businesActivitySubSel.ba_sub_sel9}>{"Unit Trusts/Mutual Funds"}</option>
                          <option value="Private Equity" selected ={businesActivitySubSel.ba_sub_sel10}>{"Private Equity"}</option>
                          <option value="Hedge Funds" selected ={businesActivitySubSel.ba_sub_sel11}>{"Hedge Funds"}</option>
                          <option value="Commodities" selected ={businesActivitySubSel.ba_sub_sel12}>{"Commodities"}</option>
                          <option value="Foreign Exchange (Forex)" selected ={businesActivitySubSel.ba_sub_sel13}>{"Foreign Exchange (Forex)"}</option>
                          <option value="Cryptocurrencies" selected ={businesActivitySubSel.ba_sub_sel14}>{"Cryptocurrencies"}</option>
                          <option value="Other" selected ={businesActivitySubSel.ba_sub_sel15}>{"Other"}</option>
                      </Input>
                      <span style={{ color: 'red' }}>{formErrors.business_activity_sub_type}</span>
                    </H6>
                     ) : null}
                  

                  {isOtherVisible ? (
                     <H6><p><Label  style={{fontSize:'16px'}}>{"Describe the type of activity:"}</Label>
                        <textarea onChange={selectChangeHandler}  name="busines_other_details" id="busines_other_details" value={otherBusinessActivity} className="form-control input_bodara" rows='3'  style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}}  />
                     </p>
                     <span style={{ color: 'red' }}>{formErrors.busines_other_details}</span>
                     </H6>
                     
                  ) : null}
                 
				        </Col>
			       </Row>				  
				     <hr />
				         {/*} <ClientNameClass register={register} errors={errors} />*/}
          
                 <H6>
                   
					
                    <FormGroup>                        
                       
                        <H6>
                          <p>
                            <Input name="assessment_score" className="form-control input_bodara" type="hidden" value={userPercentage} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} />
                         </p>
                        </H6>
						
                    </FormGroup>
					</H6></H6>))}
  
				     
               
                
      {supervisor_edit=="application_confirm" && userDetails!=null?(
        <Container fluid={true} className="credit-card">
        <Row>
            <CreditCards isApplicationEvaluated={false} isApprovingStageSupervisor={false} isChairSecretary={null} userDetails={userDetails} isPsApprover={false} approverType={"applicant"} saveBtnTxt={"Submit Application"} rejectBtnTxt={"Back"} />
           

            <Fragment>
      <Col >
        <Card className='height-equal'>
           <CardBody>
            <Row >
            <a href={`${pinagareAPIURL}?generate_pinagare_pdf=true&application_details=`+JSON.stringify(userDetails)} target="_blank"><H6>{"View As (PDF)"}</H6></a>  
			 
            </Row>
          </CardBody>
        </Card>
      </Col>
    </Fragment>

        </Row>
      </Container>

      ):(supervisor_edit=="edit" && userDetails!=null? ( <FormGroup>                        
                       
                       <H6>
                         <p>
                           <Input name="scheme_application_id" className="form-control input_bodara" type="hidden" value={userDetails.scheme_application_id} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}} />
                        </p>
                       </H6>
           
                   </FormGroup>) : (
                 <Row>
        <Col>
        
		<H6>
    {supervisor_edit!="onbehalf"? (<FormGroup>
      <p>
      <Label  style={{fontSize:'16px'}}>{"Is all prepopulated information accurate? If not, add feedback below. (Optional)"}</Label>
                <Input onChange={handleChange} name='prepopulated_data_feedback' className="form-control input_bodara" type="text" value={userDetails.prepopulated_data_feedback} style={{borderColor:'#6ec6ec !important', border:'1px solid #6ec6ec'}}  />
                
        </p>
    </FormGroup>):null}
          <FormGroup>
            <Label>{"Personal Motivation (Optional)"}</Label>
            <textarea maxLength="500" onChange={handleChange} value={userDetails.personal_statement}  style={{borderColor:'#6ec6ec', border:'2px solid #6ec6ec'}} className='form-control' name='personal_statement' rows='3'  />
            <span style={{ color: 'red' }}>{formErrors.personal_statement}</span>
          </FormGroup>
		  
					<hr />		
			<FormGroup>
			  <Row>
			   <Col>			   
			   
				
         <div>
                      <label htmlFor="acceptTermsContainer" className="form-check-label">
                    <a onClick={ toggle }> <span style={{ color: '#6ec6ec' }}>Click to View and Accept Terms & Conditions</span></a></label>
                    <span style={{ color: 'red' }}>{formErrors.acceptTerms}</span>
                    
      <CommonModal isOpen={modal} title={"Terms & Conditions"} toggler={toggle} closeBtnTxt={"Close"} disableSaveBtn={true}>
        <P>{'Before completing this form, please read the guidelines and the Terms & Conditions that have been provided to inform you about eligibility and the details of the programme: I acknowledge that I have reviewed and meet the following criteria:'}</P> 
        <P>{' •	I am currently an employee of the Botswana Public Service. '}
         <br /> {' •	My age is within the category eligible to apply. '}
         <br /> {' •	My years of service are within the category eligible to apply. '}
         <br /> {' •	I do not have a specific separation date already agreed with the Employer prior to call for application for Voluntary Separation programme '} 
         <br /> {' •	I acknowledge that this programme is voluntary and completion of this application is in no way binding me and the Employer. '}
         <br /> {' •	I understand that application for this programme does not warrant automatic approval'}
         <br /> {' •	If I decide I am no longer interested in the Programme after submitting this request, I must immediately notify the VSP Secretariat in writing within 5 days of receipt of application.'}
         <br /> {' •	I certify the information provided is true and correct. '}
         <br /> {' •	I acknowledge that I have received and read the Voluntary Separation Programme Guidelines'} 
         <br /> {' •	I will undergo mandatory counselling'} </P>
         <br /> 
        
         <Form>
          <FormGroup><hr />
                    
                    <div className='m-t-15 m-checkbox-inline custom-radio-ml'>
                        <div className='checkbox checkbox-primary' style={{paddingLeft:'12px'}}>
                            <Input onChange={handleChange} value="yes" id='acceptTerms' checked={acceptTermsChecked} name='acceptTerms' type='checkbox' className={'form-control '}  />
                            <label htmlFor="acceptTerms" className="form-check-label">
                            I accept these Terms & Conditions
                           </label>
                                <span style={{ color: 'red' }}>{formErrors.acceptTerms}</span>
                        </div>
                    </div>
                  
                </FormGroup>
                </Form>
				 
			 
      </CommonModal></div>
                 
			 </Col>
			 </Row>
			</FormGroup>
			</H6>
        </Col>
      </Row>

      
))}
				     <hr />   
               <PromiseSpinner />
                  <Row>
                    <Col sm="12">
                      <div className='text-end'>
					              <p>{" ."}</p>					  
					             {/* <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/track-application/ltp`} > */}				  
                       {supervisor_edit=="edit"? (<Btn attrBtn={{ color: 'success', className: 'me-3' }}>{"Save Application"}</Btn>) : (<Btn attrBtn={{ color: 'success', className: 'me-3' }}>{"Submit Application"}</Btn>)}
                       {/*</Link>  */}                     
                       {(supervisor_edit=="application_confirm"||supervisor_edit=="edit") && userDetails!=null? (
                        supervisor_edit=="edit"? (<Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/review-application/ltp/`+userDetails.scheme_application_id}>
                        <Btn attrBtn={{ color: 'danger' }}>{"Back"}</Btn>
                      </Link>):(<Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/application/ltp/correct_application`}>
                        <Btn attrBtn={{ color: 'danger' }}>{"Back"}</Btn>
                      </Link>))
                        : ( <Link to={`${process.env.PUBLIC_URL}/dpsm/scheme/ltp`}>
                          <Btn attrBtn={{ color: 'danger' }}>{"Back"}</Btn>
                        </Link>)} {"  "}
                        {"  "}{supervisor_edit!="edit"&&supervisor_edit!="application_confirm"? (<Btn attrBtn={{ color: 'secondary', className: 'me-3' , onClick: previewApplication}}>{"Preview Application"}</Btn>):null}
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Newproject;
